import type { JcCookieConsent } from '../../types/cookie-consent';

export function hasAnalyticsConsent(state: JcCookieConsent | null | undefined): boolean {
  return state != null && state.v === 1 && state.analytics === true;
}
